import { OPTION_TYPE } from "Common/dictionaries/optionType";
import filter from "lodash/filter";
import forEach from "lodash/forEach";
import addOrUpdateNode from "../updates/addOrUpdateNode";
import updateGroup from "../updates/updateGroup";
export default (graphComponentRef, documentObjects, selectedObjectsType, documentNodeAttributeImageRef) => (ids, fieldId, value, attributeType) => {
    const result = [];
    if (!graphComponentRef.current)
        return result;
    if (selectedObjectsType === "EdgeSource") {
        let processedEdgesCount = 0;
        graphComponentRef.current.graph.edges.every(item => {
            var _a, _b, _c, _d, _e;
            if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) ||
                !item.tag ||
                !((_c = (_b = item.sourceNode) === null || _b === void 0 ? void 0 : _b.tag) === null || _c === void 0 ? void 0 : _c.NodeId) ||
                !((_e = (_d = item.targetNode) === null || _d === void 0 ? void 0 : _d.tag) === null || _e === void 0 ? void 0 : _e.NodeId))
                return true;
            if (item.tag.EdgeId && ids.has(item.tag.EdgeId)) {
                const fromNodeName = item.sourceNode.tag.NodeName;
                const toNodeName = item.targetNode.tag.NodeName;
                item.tag = {
                    ...item.tag,
                    FromNodeName: fromNodeName,
                    ToNodeName: toNodeName,
                    [fieldId]: value
                };
                result.push(item.tag);
                processedEdgesCount += 1;
            }
            return processedEdgesCount !== ids.size;
        });
        if (processedEdgesCount > 0) {
            graphComponentRef.current.updateVisual();
        }
        return result;
    }
    let processedNodesCount = 0;
    const processed = new Set();
    const regularNodeIds = new Set();
    const groupedNodeIds = {};
    graphComponentRef.current.graph.nodes.every(item => {
        var _a, _b, _c;
        if (!item.tag)
            return true;
        if (((_a = item.tag) === null || _a === void 0 ? void 0 : _a.NodeId) && ids.has(item.tag.NodeId)) {
            regularNodeIds.add(item.tag.NodeId);
            processedNodesCount += 1;
        }
        if (((_b = item.tag) === null || _b === void 0 ? void 0 : _b.GroupId) && ((_c = item.tag) === null || _c === void 0 ? void 0 : _c.Nodes)) {
            forEach(item.tag.Nodes, n => {
                if (n.NodeId && ids.has(n.NodeId)) {
                    if (!groupedNodeIds[item.tag.GroupId])
                        groupedNodeIds[item.tag.GroupId] = new Set();
                    processedNodesCount += 1;
                    groupedNodeIds[item.tag.GroupId].add(n.NodeId);
                }
            });
        }
        return processedNodesCount !== ids.size;
    });
    forEach(Array.from(regularNodeIds), nodeId => {
        if (!graphComponentRef.current)
            return;
        const regularData = { NodeId: nodeId };
        if (attributeType) {
            regularData.AttributeValues = [
                { Key: fieldId, Value: value }
            ];
            if (documentNodeAttributeImageRef && attributeType === OPTION_TYPE.IMAGE) {
                const imgValue = value;
                if (!documentNodeAttributeImageRef.current[nodeId])
                    documentNodeAttributeImageRef.current[nodeId] = {};
                documentNodeAttributeImageRef.current[nodeId][fieldId] = imgValue;
            }
        }
        else {
            regularData[fieldId] = value;
        }
        const { node } = addOrUpdateNode(graphComponentRef, documentObjects, regularData);
        (node === null || node === void 0 ? void 0 : node.tag) && result.push(node.tag);
    });
    forEach(groupedNodeIds, (nodeIdsInGroup, groupId) => {
        var _a, _b, _c;
        const groupDataForUpdate = [];
        forEach(Array.from(nodeIdsInGroup), nodeId => {
            if (!graphComponentRef.current || processed.has(nodeId))
                return;
            const regularData = { NodeId: nodeId };
            if (attributeType) {
                regularData.AttributeValues = [
                    { Key: fieldId, Value: value }
                ];
                if (documentNodeAttributeImageRef && attributeType === OPTION_TYPE.IMAGE) {
                    const imgValue = value;
                    if (!documentNodeAttributeImageRef.current[nodeId])
                        documentNodeAttributeImageRef.current[nodeId] = {};
                    documentNodeAttributeImageRef.current[nodeId][fieldId] = imgValue;
                }
            }
            else {
                regularData[fieldId] = value;
            }
            groupDataForUpdate.push(regularData);
        });
        const groupNodes = (_c = (_b = (_a = updateGroup(graphComponentRef, groupId, groupDataForUpdate)) === null || _a === void 0 ? void 0 : _a.group) === null || _b === void 0 ? void 0 : _b.tag) === null || _c === void 0 ? void 0 : _c.Nodes;
        const updated = groupNodes
            ? filter(groupNodes, e => nodeIdsInGroup.has(e.NodeId))
            : undefined;
        forEach(updated, e => {
            result.push(e);
            processed.add(e.NodeId);
        });
    });
    return result;
};
